import { HeaderCellProps } from '../types';

export const TeamCreatedAtHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Created At</div>;
};
